import { render, staticRenderFns } from "./ExpandSwitcherIcon.vue?vue&type=template&id=1f0f3f74&scoped=true"
import script from "./ExpandSwitcherIcon.vue?vue&type=script&lang=js"
export * from "./ExpandSwitcherIcon.vue?vue&type=script&lang=js"
import style0 from "./ExpandSwitcherIcon.vue?vue&type=style&index=0&id=1f0f3f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f3f74",
  null
  
)

export default component.exports